export enum ThumbnailTriggerType {
    Hover = 'hover',
    Click = 'click'
}
